import { toast } from "react-toastify";

const error = (message) => {
  toast.error(message, {
    autoClose: 4000,
  });
};

const success = (message) => {
  toast.success(message, {
    autoClose: 4000,
  });
};

const info = (message) => {
  toast.info(message, {
    autoClose: 4000,
  });
};

export { error, success, info };
